import React, { useEffect, useState } from 'react';
import EntryRequestCreateView from '../Views/EntryRequestCreateView';
import { CustomModal, useCustomToast } from '../../../../components';
import {
  useCreateEntryReq,
  useModalSeccional,
} from '../../../../hooks/entryRequests';
import { UploadedFile, useEntryRequestFormik } from '../../../../utils';
import { EntryRequest } from '../../types';
import { useAtom } from 'jotai';
import { authAtom } from '../../../../state';

import {
  useDeliveryOptions,
  useEntryStates,
  useEntyTypes,
  useGetUtilsKeys,
} from '../../../../share';
import { ModalSeccional } from '../components';
import ModalSaveChanges from '../../../../components/ModalSaveChanges/ModalSaveChanges';

interface EntryRequestsCreateProps {
  isOpen: boolean;
  OnClose: () => void;
  setLoadingData: React.Dispatch<React.SetStateAction<boolean>>;
}

const EntryRequestCreateContainer: React.FC<EntryRequestsCreateProps> = ({
  isOpen,
  OnClose,
  setLoadingData,
}) => {
  const [isOpenSaveChanges, setiIsOpenSaveChanges] = useState(false)
  const [files, setFiles] = React.useState<UploadedFile[]>([]);
  const [authData] = useAtom(authAtom);
  const [dataFirma, setDataFirma] = useState("");
  const { mutateAsync, isPending: loadCreate } = useCreateEntryReq();
  const { data: entyTypes = [], isLoading: isLoadingEntyTypes } = useEntyTypes();
  const { data: entryStates = [], isLoading: isLoadingEntryStates } = useEntryStates();
  const { data: entryDevelivery = [], isLoading: isLoadingEntryDevelivery } = useDeliveryOptions();
  const { data: utilKeys = [] } = useGetUtilsKeys(
    'keys[]=sectionals&keys[]=asset_type&keys[]=dependencies&filter[status_id]=1',
  );

  const {showToast} = useCustomToast();
  const handledDataFirma = (data: string) => {
    setDataFirma(data)
  }

  const onSave = async (values: EntryRequest) => {
    const delivery_section = items.map((item) => ({
      section_id: item.seccional,
      invoice_number: item.factura,
      quantity: Number(item.cantidad),
    }));

    try {
      await mutateAsync({
        ...values,
        delivery_section,
        invoice_date: values.invoice_date ? new Date(values.invoice_date).toISOString().split("T")[0] : '',
        contract_start_date: values.contract_start_date ? new Date(values.contract_start_date).toISOString().split("T")[0] : '',
        contract_end_date: values.contract_end_date ? new Date(values.contract_end_date).toISOString().split("T")[0] : '',
        comodato_end_date: values.comodato_end_date ? new Date(values.comodato_end_date).toISOString().split("T")[0] : '',
        comodato_start_date: values.comodato_start_date ? new Date(values.comodato_start_date).toISOString().split("T")[0] : '',
        query_date: values.query_date ? new Date(values.query_date).toISOString().split("T")[0] : '',
        interadmin_start_date: values.interadmin_start_date ? new Date(values.interadmin_start_date).toISOString().split("T")[0] : '',
        interadmin_end_date: values.interadmin_end_date ? new Date(values.interadmin_end_date).toISOString().split("T")[0] : '',
        other_deliver: values.other_deliver,
        documents: files,
        signature_url: dataFirma,
      });
    } catch (error) {
      showToast("error", "Error al crear la solicitud")
    }
  };


  const confirmSaveChanges = async () => {
    try {
      await onSave(formik.values); // Llama a onSave con los valores actuales

      onReset() // Cierra el modal después de guardar
    } catch (error: Error | any) {
      console.error("Error al guardar:", error);
      showToast("error", String(error?.message))
    }
  };

  const validateAndOpenModal = async () => {
    const errors = await formik.validateForm(); // Ejecuta la validación manualmente
    formik.setTouched(
      Object.keys(formik.values).reduce(
        (acc: Record<string, boolean>, key) => {
          acc[key] = true;
          return acc;
        },
        {} as Record<string, boolean> // Tipo del objeto inicial
      )
    );

    if (Object.keys(errors).length === 0) {
      setiIsOpenSaveChanges(true);
    } else {
      const errorMessages = Object.entries(errors)
        .map(([_, value]) => `${value}`)
        .join('\n');

      showToast("error", errorMessages);
    }
  };

  const formik = useEntryRequestFormik({
    onSubmit: async () => {
      // Este onSubmit queda vacío porque la validación ya se maneja antes de abrir el modal
    },
  });

  const closeModalSaveChanges = () => {
    setiIsOpenSaveChanges(false);
  }

  const onReset = () => {
    setFiles([]);
    closeModalSaveChanges();
    setTimeout(() => {
      const camposAConservar = ["query_date", "requester_id", "entry_requester_section_id"];
      const updateValues = Object.keys(formik.values).reduce((acc: Partial<EntryRequest>, key) => {
        const typedKey = key as keyof EntryRequest;

        acc[typedKey] = camposAConservar.includes(key)
          ? formik.values[typedKey]
          : ("" as EntryRequest[keyof EntryRequest]);

        return acc;
      }, {} as Partial<EntryRequest>);
      formik.resetForm({ values: updateValues as EntryRequest });
      OnClose();
      onResetSeccional();
    }, 100);
  };

  //Seccional
  const {
    data: items,
    isOpen: isOpenSeccional,
    formik: formikSeccional,
    currentPage,
    totalCantidad,
    onReset: onResetSeccional,
    handlePagination: onPagination,
    handleDelete,
    setIsOpen,
  } = useModalSeccional(Number(formik.values.deliveries) || 10);

  const allDataLoaded =
    !isLoadingEntyTypes &&
    !isLoadingEntryStates &&
    !isLoadingEntryDevelivery;

  useEffect(() => {
    setLoadingData(!allDataLoaded);
  }, [allDataLoaded]);

  return (
    <CustomModal
      title="Creación de solicitud de entrada"
      labelSubmit="Crear solicitud"
      open={isOpen}
      onCancel={() => {
        onReset();
      }}
      width="95vw"
      isLoadingSave={loadCreate}
      onSave={validateAndOpenModal}
    >
      <EntryRequestCreateView
        entyTypes={entyTypes}
        itemTypes={utilKeys?.asset_type || []}
        entryDevelivery={entryDevelivery}
        entryStates={entryStates}
        authData={authData}
        sedes={utilKeys?.sectionals || []}
        dependencies={utilKeys?.dependencies || []}
        formik={formik}
        setIsOpen={setIsOpen}
        isOpen={isOpen}
        onFiles={setFiles}
        files={files}
      />
      <ModalSeccional
        items={items}
        currentPage={currentPage}
        sedes={utilKeys?.sectionals?.length ? utilKeys?.sectionals : []}
        isOpen={isOpenSeccional}
        totalCantidad={totalCantidad}
        formik={formikSeccional}
        onReset={onResetSeccional}
        onPagination={onPagination}
        handleDelete={handleDelete}
        setIsOpen={setIsOpen}
      />
      <ModalSaveChanges
        title="Guardar cambios"
        textOne="¿Está seguro de crear esta solicitud de entrada?"
        textTwo="Una vez creado no podrá realizar cambios."
        open={isOpenSaveChanges}
        width={900}
        isLoadingSave={false}
        onClose={() => {
          closeModalSaveChanges();
        }}
        labelSubmit="Aceptar"
        onSave={() => confirmSaveChanges()}
        handledDataFirma={handledDataFirma} />

    </CustomModal>
  );
};

export default EntryRequestCreateContainer;
